var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import KeySvg from './key-01.icon.svg';
export const KeyIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: KeySvg }));
_react_refresh_temp_1 = KeyIcon;
$RefreshReg$(_react_refresh_temp_1, "KeyIcon");
